import Model, { attr, belongsTo } from '@warp-drive/legacy/model';
import type FileHistoryModel from './file-history';
import { Type } from '@warp-drive/core-types/symbols';

export type LogSource = [
  'dispatch',
  'process',
  'processed',
  'processed_with_errors_or_invalid',
  'processing_invalid',
  'processing_failed',
  'insert',
][number];

export default class FileHistoryLogModel extends Model {
  /*************************
   **  Attributes         **
   *************************/
  // TODO: type this
  @attr declare detail: { note: string; changes: { [key: string]: unknown } };

  /*************************
   **  Relationships      **
   *************************/
  @belongsTo('file-history', { async: false, inverse: 'fileHistoryLogs' })
  declare fileHistory: FileHistoryModel;

  [Type] = 'file-history-log' as const;
}
